// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4061":"e2de1e1e10d214e5","6403":"9adc8ba57a805c25"}[chunkId] + ".css";
};